export default {
  streams: []
}
